<template>
  <div
    class="flex-col flex-1"
    :class="{
      'middle-presentation': true,
      'presenting-mode': $store.getters.isPresenting,
      'capture-mode': $store.state.isScreenCapture,
      'transparent-bg': $store.state.slideActive.type == 'image' &&
        $store.state.slideActive.imageType == 'background',
      'presenting-mode-share': $store.getters.isPresenting && $store.state.sharePresentation,
      'flex': !showingSlideGrid,
      'playing-demo': isPlayDemoMode,
    }"
    :style="{'width': showingSlideGrid ? '0' : 'unset' }"
  >
    <div
      class="exit-wrapper"
      @click="mobileExitFullScreen"
      v-if="!$store.state.sharePresentation && $store.getters.isPresenting & !isMSTeamsApp"
    >
      <i class="fas fa-times" />
      <span>Exit</span>
    </div>
    <TakeOverToolbar class="take-over" />
    <ContentSlideToolbar />
    <ContentAddInPPT
      v-if="showAddInPPT"
      :type="slideActive.type"
      :slideType="slideActive.slideType"
      :class="{'invisible' : invisibleAddInPPT}"
    />

    <div
      class="slide-intro"
      :class="{
        [$store.state.currentSlideCanvas]: true,
        'flex flex-col': !isPresenting,
      }"
      id="middle-slide-intro"
    >
      <div
        class="ahaslide-legacy-css wrap-slide-intro vertical layout center center-justified"
        :class="{'fit': isPresenting}"
        id="middle-canvas"
      >
        <SlideWrapper
          @selectPrevSlide="selectPrevSlide"
          @selectNextSlide="selectNextSlide"
          @handleNextSlideWhenPlayingQuiz="handleNextSlideWhenPlayingQuiz"
        />
        <SharePresentationBar />
      </div>

      <div v-if="!isBackstage">
        <MiddleYouCanHostUpTo />
        <div
          :class="{'active': $store.state.showLiveAudienceDemo}"
          class="text-center audience-mode horizontal layout center"
        >
          <ParticipantViewButton
            v-if="presentation.id"
            class="mr-2"
          />

          <ResetResultsButton
            gaAction="Editor"
            v-if="presentation.id"
          />
        </div>
      </div>

      <BackstageSlideButtons
        v-if="isBackstage"
        @selectPrevSlide="selectPrevSlide"
        @selectNextSlide="selectNextSlide"
      />

      <SlideNotes />
    </div>
  </div>
</template>
<script>
import screenfull from 'screenfull'
import interact from 'interactjs'
import { mapState, mapActions, mapGetters } from 'vuex'
import SlideNotes from './SlideNotes.vue'
import BackstageSlideButtons from '@/components-v2/presentation-editor/middle/BackstageSlideButtons.vue'
import SlideWrapper from '@/components-v2/presentation-editor/middle/SlideWrapper.vue'
import TakeOverToolbar from '@/components-v2/presentation-editor/TakeOverToolbar.vue'
import ContentSlideToolbar from '@/components-v2/presentation-editor/middle/ContentSlideToolbar.vue'
import ContentAddInPPT from '@/components-v2/presentation-editor/middle/ContentAddInPPT.vue'

import config from '@/config'
import EventBus from '@/eventBus'
import constants from '@/constant'
import QuizStatuses from '@/constant/QuizStatuses'

import util from '@/util'
import Socket from '@/socket'
import UserApi from '@/api/user'

// components
import ResetResultsButton from '@/components-v2/common/reset-results/ResetResultsButton.vue'
import ParticipantViewButton from '@/components-v2/presentation-editor/middle/ParticipantViewButton.vue'
import SharePresentationBar from '@/components-v2/presentation-editor/SharePresentationBar.vue'
import MiddleYouCanHostUpTo from '@/components-v2/presentation-editor/middle/MiddleYouCanHostUpTo.vue'
import CollabHelper from '@/helpers/collab/collab-helper'

// services
import cookie from '@/services/cookie'

import {
  SET_CURRENT_SLIDE_MODE,
  EDIT_MODE,
} from '@/vuex/types'

export default {
  components: {
    ResetResultsButton,
    ParticipantViewButton,
    SlideNotes,
    SharePresentationBar,
    MiddleYouCanHostUpTo,
    BackstageSlideButtons,
    SlideWrapper,
    TakeOverToolbar,
    ContentSlideToolbar,
    ContentAddInPPT,
  },
  data() {
    return {
      isMSTeamsApp: !!util.getParamValue('ms-teams', window.location.href),
      debouceTimeNextSlide: null,
      presentationCopyId: null,
      timer: null,
      typeChart: '',
      isGuestUser: !!cookie.getValue('aha-guest-user'),
      QuizStatuses,
      notes: '',
      isClaimingFreeOneTimeOffer: false,
      allowShowSlideType: [
        'wordCloud',
        'imageChoice',
        'multipleChoice',
        'question',
        'leaderboard',
        'spinnerWheel',
      ],
    }
  },
  computed: {
    ...mapState({
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
      isScreenCapture: (state) => state.isScreenCapture,
      activeSlideId: (state) => state.activeSlideId,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      presentation: (state) => state.presentation,
      isPlayDemoMode: (state) => state.isPlayDemoMode,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      isNewPresentation: (state) => state.isNewPresentation,
      presentationEditors: (state) => state.presentationEditors,

    }),
    ...mapGetters('presentationChat', ['isFocusingChatInput']),
    ...mapGetters(['isPresenting', 'isBackstage']),

    isABTestCollabTeamEdit() {
      if (this.presentation.accountId &&
          !this.presentation.hasSharedUser && this.presentation.accountId % 2 === 0) {
        return true
      }
      return false
    },

    tip: () => config.PRO_TIPS[
      util.randomIntFromInterval(0, config.PRO_TIPS.length - 1)
    ],

    hasPrevSlide() {
      return this.$store.getters.currentSlideIndex > 0
    },
    hasNextSlide() {
      return (
        this.$store.getters.currentSlideIndex <
        this.$store.state.presentation.slides.length - 1
      )
    },

    isHideTextShare() {
      return !!util.getParamValue('hideText', window.location.href)
    },

    showAddInPPT() {
      if (this.$store.state.sharePresentation) {
        return false
      }
      if (this.$store.state.workingMode === constants.workspace.TEAM) {
        return false
      }
      let isShowButtonWithCollab = !this.isDisableEditPresentation
      if (this.isABTestCollabTeamEdit) {
        isShowButtonWithCollab = this.showButtonWithCollab(isShowButtonWithCollab)
      }

      return config.region !== 'eu' && !this.isBackstage && isShowButtonWithCollab &&
      (this.allowShowSlideType.includes(this.slideActive.type) ||
      (this.slideActive.type === 'pickAnswer' && this.slideActive.slideType === null) ||
      (this.slideActive.type === 'pickAnswer' && this.slideActive.slideType === 'imageChoice')
      )
    },
    invisibleAddInPPT() {
      if (this.presentation.User && (this.presentation.User.id === this.currentUser.id)) {
        return false
      }
      if (this.showButtonWithCollab(false)) {
        return false
      }
      return true
    },
  },
  watch: {
    '$store.getters.isPresenting': function watchIsPresenting(isPresenting) {
      if (isPresenting) {
        document.body.classList.add('no-scroll')
        document.body.classList.add('body-presenting')
      } else {
        const { presentation } = this.$store.state
        if (presentation.showBranding || presentation.showExport ||
        presentation.showSetting || presentation.showShare) {
          document.body.classList.remove('body-presenting')
        } else {
          document.body.classList.remove('no-scroll')
          document.body.classList.remove('body-presenting')
        }

        // when exit presenting mode
        if (this.$store.state.slideActive.type === 'pickAnswer') {
          this.updateSlideActiveAction({
            quizStatus: constants.QuizStatuses.LOBBY_SCREEN,
            hideResult: false,
            showCorrectOption: true,
          })
        }
      }

      if (this.$store.state.continueQuiz) {
        this.$store.state.continueQuiz = false
      }
      this.$store.state.presentation.presenting = isPresenting
      CollabHelper.getListUsersEditPresentation()
    },
  },
  destroyed() {
    EventBus.$off('template-preview:go-to-slide', this.goToSlide)
    if (window.innerWidth > 800) {
      if (screenfull && screenfull.off) {
        screenfull.off('change')
      }
    }

    this.$store.dispatch(SET_CURRENT_SLIDE_MODE, '')
    document.body.classList.remove('no-scroll')
    document.body.classList.remove('body-presenting')
  },

  mounted() {
    EventBus.$on('template-preview:go-to-slide', this.goToSlide)
    this.handleShowControlsOnHoverDevices()
    this.handleShowControlsOnTouchDevices()
    const self = this

    if (window.innerWidth >= 800) {
      if (!screenfull || !screenfull.on) return
      screenfull.on('change', () => {
        EventBus.$emit('context-menu: update showContextMenu', false)
        if (!this.isMSTeamsApp && !screenfull.isFullscreen && self.$store.getters.isPresenting
          && !self.$store.getters.isWindowedMode) {
          self.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
          this.$http.put(
            config.api.updatePresentation + this.$store.state.presentation.id,
            {
              presenting: false,
              socketId: Socket.getSocketId(),
              accessCode: this.$store.state.presentation.uniqueAccessCode,
            },
          )
          this.$router.replace({
            name: 'PresentationDetail',
            params: { id: this.$store.state.presentation.id },
          })
        }
      })
    }

    function endDrag(event) {
      const { target } = event
      target.classList.remove('draging')
    }
    interact('.live-demo-audience').draggable({
      // enable inertial throwing
      inertia: true,
      // keep the element within the area of it's parent
      // enable autoScroll
      autoScroll: true,

      // call this function on every dragmove event
      // eslint-disable-next-line no-use-before-define
      onmove: dragMoveListener,
      // call this function on every dragend event
      onend: endDrag,
    })

    function dragMoveListener(event) {
      const { target } = event
      // keep the dragged position in the data-x/data-y attributes
      const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy

      // translate the element
      if (!self.enableABtestParticipeatView) {
        target.style.transform = `scale(0.8) translate(${x}px, ${y}px)`
      } else {
        target.style.transform = `scale(0.65) translate(${x}px, ${y}px)`
      }
      target.style.webkitTransform = target.style.transform

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
      target.classList.add('draging')
    }

    // this is used later in the resizing and gesture demos
    window.dragMoveListener = dragMoveListener

    const isEmbed = util.getParamValue('embedded')
    if (isEmbed) {
      this.$store.state.isPlayDemoMode = true
    }
  },
  methods: {
    ...mapActions([
      'updateSlideActiveAction',
      'setCurrentUserAction',
    ]),

    showButtonWithCollab(isShowButtonWithCollab) {
      const slideActive = this.presentation.slides.find((slide) => slide.id === this.slideActive.id)
      if (slideActive) {
        const { usersOnline } = slideActive
        if (usersOnline) {
          const currentUserSlide = usersOnline.find((userInfo) => userInfo.user.id === this.currentUser.id)
          if (currentUserSlide) {
            return currentUserSlide.isCanEdit
          }
        }
      }
      return isShowButtonWithCollab
    },

    _checkShowingAnimationImgSlideBackground() {
      const { isPresenting } = this.$store.getters

      if (this.imageSlideBackgroundVisible && isPresenting) {
        this.showingAnimationImgSlideBackground = true
      } else if (this.imageSlideBackgroundVisible && !isPresenting) {
        this.showingAnimationImgSlideBackground = false
      }
    },
    checkBulletPointsPresenting(isPresenting) {
      if (this.$store.state.slideActive.type == 'bulletPoints') {
        const options = []
        this.$store.state.slideActive.SlideOptions.forEach((item) => {
          if (item.title) {
            options.push(item)
          }
        })

        if (!options.length) {
          if (isPresenting) {
            this.updateSlideActiveAction({
              SlideOptions: options,
            })
          } else {
            this.updateSlideActiveAction({
              SlideOptions: [
                {
                  index: 1,
                  order: 1,
                },
                {
                  index: 2,
                  order: 2,
                },
                {
                  index: 3,
                  order: 3,
                },
              ],
            })
          }
        } else if (isPresenting) {
          this.updateSlideActiveAction({
            SlideOptions: options,
          })
        }
      }
    },

    handleNextSlideWhenPlayingQuiz(type) {
      if (type === 'next') {
        this._autoNextSlide('keyboard')
      }

      if (type === 'prev') {
        this._autoPrevSlide('keyboard')
      }
    },
    handleShowControlsOnHoverDevices() {
      if (util.supportsTouch()) return
      this.$el.addEventListener('mousemove', () => {
        this.handleShowSlideControls()
      })
    },

    handleShowControlsOnTouchDevices() {
      if (!util.supportsTouch()) return
      this.$el.addEventListener('touchstart', () => {
        this.handleShowSlideControls()
      })
    },

    handleShowSlideControls() {
      if (this.isPresenting) {
        EventBus.$emit('next-back-slide-arrows: update isShowingControls', true)
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            EventBus.$emit('next-back-slide-arrows: update isShowingControls', false)
          }, config.SLIDE_CONTROLS_TIMEOUT)
        } else {
          this.timer = setTimeout(() => {
            EventBus.$emit('next-back-slide-arrows: update isShowingControls', false)
          }, config.SLIDE_CONTROLS_TIMEOUT)
        }
      }
    },

    _getCurrentIndexSlide(currentSlideId) {
      return this.$store.state.presentation.slides.findIndex((item) => {
        return item.id == currentSlideId
      })
    },
    selectPrevSlide(mode) {
      if (!this.$store.state.sharePresentation && this.$store.state.slideActive.type == 'pickAnswer'
        && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.LOBBY_SCREEN
        && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.RESULT_SCREEN) {
        const index = this.$store.state.presentation.slides.findIndex((item) => {
          return item.id == this.$store.state.slideActive.id
        })
        if (index === 0) {
          return
        }
        this.$store.state.quizConfirmation = true
        this.$store.state.quizConfirmationType = 'prev'
        util.gaTrackEvent(
          'Quiz Exit Confirmation',
          'Quiz Exit Confirmation open modal',
          'Quiz Exit Confirmation open modal prev',
        )
        util.uploadSlide(
          this.$store.state.slideActive,
          this.$store.state.presentation,
        )
        return
      }
      if (
        mode != 'icon-arrow-right' &&
        mode != 'icon-arrow-left' &&
        mode != 'swipe'
      ) {
        if (!this.checkShowAllBulletPoints('prev')) {
          EventBus.$emit('next-back-slide: update-bulletPointsIndex', this.checkShowAllBulletPoints('prev'), 'prev')
          return
        }
      }

      if (!this.hasPrevSlide) return
      this._autoPrevSlide(mode)
    },

    _autoPrevSlide(mode) {
      this.$store.state.controllerSocketId = Socket.getSocketId()

      const oldSlide = JSON.parse(JSON.stringify(this.$store.state.slideActive))
      const currentSlideId = oldSlide.id
      this.$store.dispatch('updateSlideActive', {
        activeTab: null,
        id: null,
      })
      if (this.$store.state.continueQuiz) {
        this.$store.state.continueQuiz = false
      }
      this.$store.state.transitionContent = ''
      setTimeout(() => {
        const item = this.$store.state.presentation.slides[
          this._getCurrentIndexSlide(currentSlideId) - 1
        ]
        this.$store.dispatch('setSlideActive', item)
        EventBus.$emit('updateNextSlide', item.id)

        this.$store.state.transitionContent = 'left'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')
      }, 0)
      util.gaTrackEvent(
        constants.gaCategories.PRESENTING_MODE,
        `Presentation > Presenting > Previous slide using ${mode}`,
        null,
        null,
        {
          qrCodeOpening: this.$store.state.isQRCodeVisible,
        },
      )
    },
    checkShowAllBulletPoints(mode) {
      const {
        type, showAllBulletPoints, SlideOptions, bulletPointsIndex,
      } = this.slideActive
      if (type !== 'bulletPoints' || showAllBulletPoints) return true
      if (mode == 'next') {
        if (SlideOptions && SlideOptions.length > bulletPointsIndex) return false
        return true
      }
      if (mode == 'prev') {
        if (!bulletPointsIndex) return true
        return false
      }
      return true
    },

    selectNextSlide(mode) {
      if (mode != 'keyboard') {
        this.$store.state.historyKeyboard = null
      }
      if (!this.$store.state.sharePresentation && this.$store.state.slideActive.type == 'pickAnswer'
        && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.LOBBY_SCREEN
        && this.$store.state.slideActive.quizStatus != constants.QuizStatuses.RESULT_SCREEN
        && this.$store.state.slideActive.id != this.$store.state.presentation.lastSlide) {
        this.$store.state.quizConfirmation = true
        this.$store.state.quizConfirmationType = 'next'
        util.gaTrackEvent(
          'Quiz Exit Confirmation',
          'Quiz Exit Confirmation open modal',
          'Quiz Exit Confirmation open modal next',
        )

        util.uploadSlide(
          this.$store.state.slideActive,
          this.$store.state.presentation,
        )
        return
      }
      if (
        mode != 'icon-arrow-right' &&
        mode != 'icon-arrow-left' &&
        mode != 'swipe'
      ) {
        if (!this.checkShowAllBulletPoints('next')) {
          EventBus.$emit('next-back-slide: update-bulletPointsIndex', this.checkShowAllBulletPoints('next'), 'next')
          return
        }
      }
      if (!this.hasNextSlide) return
      this._autoNextSlide(mode)
    },

    _autoNextSlide(mode) {
      this.$store.state.controllerSocketId = Socket.getSocketId()

      const oldSlide = JSON.parse(JSON.stringify(this.$store.state.slideActive))
      const currentSlideId = oldSlide.id

      this.$store.dispatch('updateSlideActive', {
        activeTab: null,
        id: null,
      })
      this.$store.state.transitionContent = ''
      setTimeout(() => {
        if (!currentSlideId) return
        const nextIndex = this._getCurrentIndexSlide(currentSlideId) + 1
        const item = this.$store.state.presentation.slides[nextIndex]

        this.$store.dispatch('setSlideActive', item)
        this.$store.state.transitionContent = 'right'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')

        // Handle preload images, etc
        this.$emit('nextSlideHandler', nextIndex)
        EventBus.$emit('updateNextSlide', item.id)
        this._handleUpdateLiveDemoLastSlide(nextIndex, this.$store.state.presentation.slides.length)
      }, 0)
      util.gaTrackEvent(
        constants.gaCategories.PRESENTING_MODE,
        `Presentation > Presenting > Next slide using ${mode}`,
        null,
        null,
        {
          qrCodeOpening: this.$store.state.isQRCodeVisible,
        },
      )
    },

    goToSlide(currentSlideId) {
      this.$store.state.transitionContent = ''
      this.$store.dispatch('updateSlideActive', {
        activeTab: null,
        id: null,
      })
      setTimeout(() => {
        if (!currentSlideId) return
        const index = this.$store.state.presentation.slides.findIndex((slide) => {
          return slide.id == currentSlideId
        })
        const item = this.$store.state.presentation.slides[index]
        if (!item) return
        this.$store.dispatch('setSlideActive', item)
        this.$store.state.transitionContent = 'right'
        EventBus.$emit('changeShowingAnimationClass', true)
        EventBus.$emit('checkShowingAnimationImgSlideBackground')
        EventBus.$emit('setValueForTransition')
        EventBus.$emit('updateValueWhenTransitionEnds')

        // Handle preload images, etc
        this.$emit('nextSlideHandler', index)
        EventBus.$emit('updateNextSlide', item.id)
        this._handleUpdateLiveDemoLastSlide(index, this.$store.state.presentation.slides.length)
      }, 0)
    },

    _handleUpdateLiveDemoLastSlide(nextIndex, slideCount) {
      try {
        if (!this.isPlayDemoMode) return
        if (nextIndex == (slideCount - 1)) {
          const playedPresentationIds = this.currentUser.playedPresentationIds || []
          playedPresentationIds.push(this.$store.state.presentation.slides[nextIndex].id)
          UserApi.patchUserById(this.currentUser.id, {
            playedPresentationIds,
          })
          util.gaTrackEvent(
            'Presentation Edtior',
            'Live Demo > Finish Live Demo',
          )
        }
        let userTag = 'other'
        if (this.currentUser.personalInformation &&
          this.currentUser.personalInformation.useAhaSlidesFor) {
          userTag = this.currentUser.personalInformation.useAhaSlidesFor
        }
        util.gaTrackEvent(
          'Presentation Edtior',
          'Live demo > Change slide',
          userTag,
          nextIndex,
        )
      } catch {
        // do nothing
      }
    },

    mobileExitFullScreen() {
      if (!this.isPresenting) return
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.$store.state.presentation.id },
      })
      this.$emit('hideFullScreen')
      util.gaTrackEvent(
        'Slide',
        'Mobile exit fullscreen',
        'Presenter switch to edit mode on mobile',
      )
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.presenting-mode {
  &::v-deep {
    .transition-image-slide-bg {
      transition: background-image cubic-bezier(0.25, 1, 0.5, 1) 0.5s;
    }
    .slide-base-colour {
      transition: background-color cubic-bezier(0.25, 1, 0.5, 1) 0.5s;
    }
  }
}
.audience-mode {
  padding-bottom: 16px;
  display: flex;
  justify-content: center;
}
.exit-wrapper {
  font-size: 86%;
  position: fixed;
  top: 3px;
  right: 4px;
  color: #fff;
  z-index: 160;
  display: none;
  cursor: pointer;
  .fas {
    padding-right: 5px;
  }
  @media (max-width: 768px) {
    display: block;
  }
}
.middle-presentation {
  position: relative;
  overflow-y: hidden;
  transition: all 0.3s ease;
}

.slide-intro {
  width: 100%;
  height: 100%;
  padding-top: 12px;

  &::v-deep .main-slide {
    position: relative;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: hidden;
  }
}
.middle-presentation.presenting-mode {
  background-color: #000;
}

.middle-presentation {
  & ::v-deep .slide-intro {
    .slide-content {
      padding: 8px;
      &.ideas-slide-content {
        padding: 8px 19px;
      }
    }
    .title-slide {
      line-height: 1.2;
      word-break: break-word;
    }
  }
}

.wrap-slide-intro {
  margin-bottom: 12px;
}

.middle-presentation.presenting-mode {
  overflow: hidden;
  background-color: #000;

  .wrap-slide-intro {
    background-color: #000;
    box-shadow: none;
    border-radius: 0;
    padding-top: initial;
    border: 0;
    height: 100%;
  }

  & ::v-deep .slide-intro {
    padding: 0;
    padding-bottom: 0;
    .main-slide {
      box-shadow: none;
      border-radius: 0;
      padding-top: initial;
      border: 0;
    }

    .top-header {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}

.middle-presentation.capture-mode {
  overflow-y: auto;
  overflow-x: hidden;
}

//Set font size for shared presentation Iphone5/se
@media (max-width: 568px) and (orientation: landscape) {
  .shared__presentation-title {
    font-size: 13px;
  }
  .shared__copy-presentation .btn {
    font-size: 12px;
  }
}

@media (max-width: 768px) {
  .take-over {
    display: none;
  }
}

.playing-demo {
  &::v-deep .slide-control {
    opacity: 1;
  }
  &.middle-presentation {
    background-color: transparent;
  }

  &::v-deep .main-slide {
    border: 0 !important;
  }

  &::v-deep .slide-container {
    box-shadow: none;
  }

  .wrap-slide-intro {
    background-color: transparent !important;
  }
}

.middle-presentation {
  background: #f0f2f5;
  .slide-intro {
    &.screen-hd {
      font-size: 18px;
    }
  }
}
</style>
